import {
    WarehouseEvents
} from "@/services/warehouse.service";

const state = {
    selectedRange: null,
    search: {
        issue_date: null
    },
    issuances: [],
    constructions: [],
    types: {
        wz: "Wydanie zewnętrzne",
        zw: "Zwrot zewnętrzny",
        pmb: "Przyjęcie z budowy",
        sp: "Sprzedaż materiałów"
    }
};

const getters = {
    search: state => {
        return state.search;
    },
    issuances: state => {
        return state.issuances;
    },
    selectedRange: state => {
        return state.selectedRange;
    },
    types: state => {
        return state.types;
    },
    constructions: state => {
        return state.constructions;
    }
};

const actions = {
    async doSearch({
        commit
    }, query) {
        //TODO: QUERY TYPE SP TESTTESTTEST
        query.type = 'wz,zw,pmb,sp';
        let issuances = await WarehouseEvents.search(query);
        let constructions = [];
        //FIlter uniq constructions
        for (var i = 0; i < issuances.length; i++) {
            if (issuances[i].construction !== undefined) {
                let constructionId = issuances[i].construction.id || null;
                if (
                    constructions.findIndex((item) => item.id === constructionId) === -1
                ) {
                    constructions.push(issuances[i].construction);
                }

            } else {

                continue }

        }
        commit("constructions", constructions);
        commit("issuances", issuances);
        return issuances;
    },
    async create({
        commit
    }, form) {
        let issuance = await WarehouseEvents.create(form);
        commit('push', issuance);
        return issuance;
    },
    async remove({
        commit
    }, issuanceid) {
        await WarehouseEvents.remove(issuanceid);
        commit('remove', issuanceid)
        return;
    }
};

const mutations = {
    search(state, {
        type,
        value
    }) {
        state.search[type] = value;
    },
    range(state, {
        selected,
        range
    }) {
        state.selectedRange = selected;
        state.search.issue_date = range;
    },
    constructions(state, payload) {
        state.constructions = payload;
    },
    issuances(state, payload) {
        state.issuances = payload;
    },
    push(state, payload) {
        state.issuances.unshift(payload);
    },
    remove(state, id) {
        let issuanceIndex = state.issuances.findIndex((item) => (item.id === id));
        if (issuanceIndex >= 0)
            state.issuances.splice(issuanceIndex, 1)
    },
    reset(state) {
        state.issuances = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
